import React, { createContext, useState, useCallback, useEffect } from "react";
import FieldPulse from "~/services/fieldpulse";
import Engage from "~/services/engage";

const TeamContext = createContext({});

export function TeamProvider({ children }) {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [members, setMembers] = useState([]);
  const [users, setUsers] = useState([]);
  const [teams, setTeams] = useState([]);

  const getMembers = useCallback(async () => {
    setLoading(true);
    setError(null);
    const res = await FieldPulse.getTeamMembers();
    if (res.error) setError(res.response);
    else {
      setMembers(res.response);
    }
    setLoading(false);
  }, [members, setMembers, setLoading, setError]);

  const getUsers = useCallback(async () => {
    setLoading(true);
    setError(null);
    const res = await Engage.getUsers();
    if (res.error) setError(res.response);
    else {
      setUsers(res.response);
    }
    setLoading(false);
  }, [users, setUsers, setLoading, setError]);

  const getTeams = useCallback(async () => {
    setLoading(true);
    setError(null);
    const res = await FieldPulse.getTeams();
    if (res.error) setError(res.response);
    else {
      setTeams(res.response);
    }
    setLoading(false);
  }, [teams, setTeams, setLoading, setError]);

  return (
    <TeamContext.Provider
      value={{
        loading,
        error,
        members,
        users,
        teams,
        getMembers,
        getTeams,
        getUsers,
      }}
    >
      {children}
    </TeamContext.Provider>
  );
}

export default TeamContext;
